import { IconButton, SvgIcon } from '@mui/material';
import { FC, useState } from 'react';
import FilterIcon from '../../../../../../../../icons/svg/filter.svg?react';
import { TableRoofFilterDrawer, TableRoofFilterDrawerProps } from './drawer';

type Props = {
  renderFilter: TableRoofFilterDrawerProps['renderFilter'];
};

export const TableRoofFilter: FC<Props> = ({ renderFilter }) => {
  const [filterOpen, setFilterOpen] = useState(false);

  return (
    <>
      <IconButton
        disableRipple
        onClick={() => setFilterOpen(true)}
        sx={{
          '&:hover > svg': {
            color: 'grey.900'
          },
          borderRadius: '8px'
        }}
      >
        <SvgIcon component={FilterIcon} color="primary" />
      </IconButton>
      <TableRoofFilterDrawer
        open={filterOpen}
        closeDrawer={() => setFilterOpen(false)}
        renderFilter={renderFilter}
      />
    </>
  );
};
